import Event from '../../core/Event';
import Customer from '../../../domain/Customer';

export default class CustomerUpdateRequested extends Event {
    public static type = 'CustomerUpdateRequested';

    constructor(public readonly id: string, public readonly customer: Partial<Customer>) {
        super(CustomerUpdateRequested.type);
    }
}



// WEBPACK FOOTER //
// ./src/application/admin/events/CustomerUpdateRequested.ts